// extracted by mini-css-extract-plugin
module.exports = {"mask":"_5D3ndNAz","mask__card":"_5D3skZGk","mask__title":"_5D344bho","mask__message":"_5D3QARVq","mask__button":"_5D1yWyP0","mask__button-decline":"_5D3lixvT"};